import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { useQuery as useGetCreditReportStatus } from "@faire/web-api--source/endpoints/www/api/retailer/credit-report-status/get-hooks";
import { IRetailerCreditReport } from "@faire/web-api--source/indigofair/data/IRetailerCreditReport";
import { route as openWithFaireNMIRoute } from "@faire/web-api--source/routes/www/open-with-faire-additional-info";
import { useLocation } from "react-router-dom";

export const useIsNMIApplication = () => {
  const { pathname } = useLocation();
  const { data, isLoading } = useGetCreditReportStatus();

  const isOnNMIRoute = pathMatchesRoute(pathname, openWithFaireNMIRoute);
  const isNoHitNMI =
    data?.detailed_credit_report_status ===
      IRetailerCreditReport.CreditReportStatus.NO_CREDIT_REPORT_FOUND ||
    data?.detailed_credit_report_status ===
      IRetailerCreditReport.CreditReportStatus.REQUEST_TIMEOUT;
  const isFrozenCreditNMI =
    data?.detailed_credit_report_status ===
      IRetailerCreditReport.CreditReportStatus.FROZEN_CREDIT_SCORE ||
    data?.detailed_credit_report_status ===
      IRetailerCreditReport.CreditReportStatus.INSUFFICIENT_CREDIT_SCORE;

  return {
    isLoadingCreditReportStatus: isLoading,
    isNMIApplication: isOnNMIRoute,
    isNoHitNMI: isNoHitNMI,
    isFrozenCreditNMI: isFrozenCreditNMI,
  };
};
